<template lang="pug">
form#belief-statement-form(@submit.prevent="submit" name="belief-statement-form" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        position="is-centered"
        expanded
      )
        b-tab-item(label="Details")
          b-field(label="Heading")
            b-input(
              :value="statement.heading"
              @input="set($event, 'heading')"
            )
          b-field(label="Body")
            b-input(
              type="textarea"
              rows="5"
              :value="statement.body"
              @input="set($event, 'body')"
            )
          b-field(label="Scriptures")
            b-taginput(
              type="is-primary"
              :value="statement.scriptures"
              @input="set($event, 'scriptures')"
              allow-new
            )
        b-tab-item(label="Image")
          cover-art-tab(
            v-model="image"
            :default-image="defaultImage"
            @input="img => image = img"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) {{ saveBtnLabel }}
      a.button.is-danger(
        @click="confirmDelete"
        :class="{ 'is-loading': settings.deleting }"
      ) Delete
</template>

<script>
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'belief-statement-form',
  components: {
    CoverArtTab,
  },
  computed: {
    ...mapGetters({
      statement: getters.GET_BELIEF_STATEMENT,
    }),
    defaultImage() {
      if (this.statement._embedded.image.id) {
        return this.statement._embedded.image.file.url;
      }
      return null;
    },
    isNew() {
      return this.statement.id === undefined;
    },
    saveBtnLabel() {
      return this.isNew ? 'Save Belief Statement' : 'Save Changes';
    },
    title() {
      return this.isNew ? 'New Belief Statement' : 'Edit Belief Statement';
    },
  },
  data() {
    return {
      image: null,
      settings: {
        deleting: false,
        submitting: false,
      },
    };
  },
  methods: {
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this statement cannot be undone',
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Yes, Delete',
        onConfirm: () => this.delete(),
      });
    },
    async delete() {
      if (!this.settings.deleting) {
        this.settings.deleting = true;
        await this.$store.dispatch(actions.DO_DELETE_BELIEF_STATEMENT, {
          id: this.statement.id,
          ignore: true,
        });
        this.$parent.close();
        this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: 'Registration deleted',
        });
        this.settings.deleting = false;
      }
    },
    async submit() {
      this.settings.submitting = true;
      const action = this.isNew ? actions.DO_CREATE_BELIEF_STATEMENT : actions.DO_UPDATE_BELIEF_STATEMENT;
      const payload = {
        id: this.statement.id,
        body: this.statement.body,
        heading: this.statement.heading,
        scriptures: this.statement.scriptures.join(','),
        zoom: 'image',
      };
      if (this.image) {
        const file = this.image.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.image_id = data.images[0].id;
      }
      const response = await this.$store.dispatch(action, payload);
      this.$parent.close();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
      this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
    },
    set(val, key) {
      this.$store.commit(mutations.SET_BELIEF_STATEMENT_FIELD, {
        key,
        val,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/BeliefStatementForm.vue